export enum FieldType {
  Text = "TEXT",
  Textarea = "TEXTAREA",
  Number = "NUMBER",
  Decimal = "DECIMAL",
  Date = "DATE",
  Datetime = "DATETIME",
  Select = "SELECT",
  MultiSelect = "MULTISELECT",
  Checkbox = "CHECKBOX",
  Radio = "RADIO",
  File = "FILE",
  Photo = "PHOTO",
  Section = "SECTION",
  Divider = "DIVIDER",
  Table = "TABLE",
  Calculated = "CALCULATED",
  Readonly = "READONLY"
}

export interface FormField {
  id: string; // Internal technical ID (UUID)
  code: string; // Stable code used for binding/rules
  type: FieldType;
  label: string;
  description?: string;
  placeholder?: string;
  required: boolean;
  readonly: boolean;
  hidden: boolean;
  defaultValue?: any;
  helpText?: string;
  order: number;
  width: "25%" | "33%" | "50%" | "66%" | "75%" | "100%"; // Grid system

  // Validations specific to field type
  validation?: {
    min?: number;
    max?: number;
    minLength?: number;
    maxLength?: number;
    pattern?: string;
  };

  // Visibility and Rules Bindings
  visibilityRules?: string[]; // IDs of rules that govern visibility
  
  // Data Integration
  dataBinding?: string; // Path to system data binding if any
  catalogBinding?: string; // ID of a StudioCatalog to load options from
  formulaBinding?: string; // ID of a formula to calculate value
  
  // For sections / nested fields (like Table columns)
  fields?: FormField[];
}

export interface FormSchema {
  fields: FormField[];
}
